import styled from 'styled-components';
import { getThemeByPath } from '~/utils';

type StartProps = {
  startColor?: ColorThemeKeys;
};

type StopProps = {
  stopColor?: ColorThemeKeys;
};

const defaultSVGSize = 64;
const defaultSVGSizeMobile = 32;

const bkpTablet = getThemeByPath('breakpoints.tablet');

const handleStartColor = ({ startColor = 'colors.primary.main' }: StartProps) =>
  getThemeByPath(startColor);

const handleStopColor = ({ stopColor = 'colors.secondary.main' }: StopProps) =>
  getThemeByPath(stopColor);

export const Svg = styled.svg`
  width: ${defaultSVGSize}px;
  height: ${defaultSVGSize}px;

  @media (max-width: ${bkpTablet}px) {
    width: ${defaultSVGSizeMobile}px;
    height: ${defaultSVGSizeMobile}px;
  }
`;

export const Start = styled.stop<StartProps>`
  stop-color: ${handleStartColor};
`;

export const Stop = styled.stop<StopProps>`
  stop-color: ${handleStopColor};
`;
